import { StorageUtil } from './storage';

export const setToken = (token: string) => {
  StorageUtil.setItem('token', token);
  document.cookie = `token=${token}; max-age=2592000; path=/`;
};
export const getToken = () => {
  const token = StorageUtil.getItem('token');
  // adding token to cookie if not present
  if (token) {
    document.cookie = `token=${token}; max-age=2592000; path=/`;
  }
  return token;
};
export const removeToken = () => {
  StorageUtil.removeItem('token');
  document.cookie = 'token=; max-age=0; path=/';
};
let sessionExpireHandler: () => void = null;

export const setSessionExpireHandler = (handler: () => void) => {
  sessionExpireHandler = handler;
};

export const triggerSessionExpiration = () => {
  sessionExpireHandler?.();
};

export const setDemoAccountToken = (demoAccountToken: string) => {
  sessionStorage.setItem('demoAccountToken', demoAccountToken);
};

export const getDemoAccountToken = () => {
  const demoAccountToken = sessionStorage.getItem('demoAccountToken');
  return demoAccountToken;
};

export const removeDemoAccountToken = () => {
  sessionStorage.removeItem('demoAccountToken');
};

export const getCurrentToken = () => {
  const demoAccountToken = getDemoAccountToken();

  if (demoAccountToken) {
    return demoAccountToken;
  }

  const token = getToken();
  return token;
};
